import { useCallback, useEffect, useState } from "react";
export function useEnvironments() {
    var _a = useState([]), environments = _a[0], setEnvironments = _a[1];
    var fetchEnvironments = useCallback(function () {
        var url = process.env.REACT_APP_SETTINGS_HOST + "/environments.php?showall&rcode=" + process.env.REACT_APP_RCODE;
        fetch(url)
            .then(function (r) { return r.json(); })
            .then(function (result) {
            setEnvironments(result);
        });
    }, []);
    useEffect(function () {
        fetchEnvironments();
    }, [fetchEnvironments]);
    return { environments: environments };
}
